/**
 * 购物车接口
 * 
 * @author 张子超
 * @since 2018-04-04
 */
import common from './common'
import store from './store'

var ApiList = {};

//API 接口



/**
 * 获取购物车列表
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getCartList = function (okCb, failCb) {
    var p = {}
    
    if (store.loginedUser.easyUser) {
        common.Api('/customer/api/easyShopcart/get.json', p, okCb, failCb)
    } else {
        common.Api('/customer/api/shopcart/get.json', p, okCb, failCb)
    }
}

/**
 * 添加进购物车
 * @param {*} skuId 
 * @param {*} count 
 * @param {*} force  
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.addCart = function (skuId, count, force, okCb, failCb) {
    var p = {
        skuId,
        count,
        force
    }
    if (store.loginedUser.easyUser) {
        common.Api('/customer/api/easyShopcart/add.json', p, okCb, failCb)
    } else {
        common.Api('/customer/api/shopcart/add.json', p, okCb, failCb)
    }
}


/**
 * 删除购物车
 * @param {*} skuIds
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.removeCart = function (skuIds, okCb, failCb) {
    var p = {
        skuIds
    }
    common.Api('/customer/api/shopcart/remove.json', p, okCb, failCb)
}

/**
 * 获取购物车数量
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getCartCount = function ( okCb, failCb) {
    var p = {
    }
    common.Api('/customer/api/shopcart/getCount.json', p, okCb, failCb)
}


export default ApiList;


// WEBPACK FOOTER //
// ./src/api/cart-api.js